import React from "react";
import {
  AnnouncementBanner,
  ALLOWED_VARIANTS,
} from "../common/LoginAnnouncement";
import { hasAnnouncementContent, VARIANT_LABELS } from "./systemSettingsUtils";

function AnnouncementSettingsForm({
  announcement,
  loading,
  savingAnnouncement,
  updateAnnouncement,
  handleSaveAnnouncement,
}) {
  if (loading) {
    return <div className="text-muted">Ładowanie...</div>;
  }

  return (
    <>
      <div className="form-check form-switch mb-3">
        <input
          id="system-announcement-enabled"
          className="form-check-input"
          type="checkbox"
          checked={announcement.enabled}
          onChange={(event) =>
            updateAnnouncement("enabled", event.target.checked)
          }
        />
        <label
          className="form-check-label"
          htmlFor="system-announcement-enabled"
        >
          Włącz komunikat na stronie logowania
        </label>
        <div className="form-text">
          Wyłączenie ukrywa komunikat natychmiast, bez usuwania wpisanej treści
          i dat.
        </div>
      </div>

      <div className="row g-3">
        <div className="col-12 col-lg-8">
          <label className="form-label">Tytuł</label>
          <input
            className="form-control"
            maxLength="200"
            value={announcement.title}
            onChange={(event) => updateAnnouncement("title", event.target.value)}
          />
        </div>
        <div className="col-12 col-lg-4">
          <label className="form-label">Wariant</label>
          <select
            className="form-control form-select"
            value={announcement.variant}
            onChange={(event) =>
              updateAnnouncement("variant", event.target.value)
            }
          >
            {Array.from(ALLOWED_VARIANTS).map((variant) => (
              <option key={variant} value={variant}>
                {VARIANT_LABELS[variant]}
              </option>
            ))}
          </select>
          <div className="form-text">Wariant zmienia kolor i wagę komunikatu.</div>
        </div>

        <div className="col-12">
          <label className="form-label">Treść</label>
          <textarea
            className="form-control"
            rows="5"
            value={announcement.message}
            onChange={(event) =>
              updateAnnouncement("message", event.target.value)
            }
          />
        </div>

        <div className="col-12 col-lg-6">
          <label className="form-label">Tekst linku</label>
          <input
            className="form-control"
            maxLength="100"
            value={announcement.linkLabel}
            onChange={(event) =>
              updateAnnouncement("linkLabel", event.target.value)
            }
          />
        </div>
        <div className="col-12 col-lg-6">
          <label className="form-label">Adres linku</label>
          <input
            className="form-control"
            maxLength="500"
            value={announcement.linkUrl}
            onChange={(event) =>
              updateAnnouncement("linkUrl", event.target.value)
            }
          />
        </div>

        <div className="col-12">
          <div className="form-check">
            <input
              id="system-announcement-new-tab"
              className="form-check-input"
              type="checkbox"
              checked={announcement.openInNewTab}
              onChange={(event) =>
                updateAnnouncement("openInNewTab", event.target.checked)
              }
            />
            <label
              className="form-check-label"
              htmlFor="system-announcement-new-tab"
            >
              Otwieraj link w nowej karcie
            </label>
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <label className="form-label">Wyświetlaj od</label>
          <input
            className="form-control"
            type="datetime-local"
            value={announcement.displayFrom}
            onChange={(event) =>
              updateAnnouncement("displayFrom", event.target.value)
            }
          />
          <div className="form-text">
            Zostaw puste, jeśli komunikat ma być widoczny od razu po zapisaniu.
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <label className="form-label">Wyświetlaj do</label>
          <input
            className="form-control"
            type="datetime-local"
            value={announcement.displayTo}
            onChange={(event) =>
              updateAnnouncement("displayTo", event.target.value)
            }
          />
          <div className="form-text">
            Zostaw puste, jeśli komunikat ma pozostać aktywny bez daty końcowej.
          </div>
        </div>
      </div>

      <div className="mt-4">
        <label className="form-label">Podgląd</label>
        {hasAnnouncementContent(announcement) ? (
          <AnnouncementBanner announcement={announcement} />
        ) : (
          <div className="border rounded-3 p-3 text-muted">
            Brak treści komunikatu.
          </div>
        )}
      </div>

      <div className="d-flex mt-4">
        <button
          type="button"
          className="btn btn-primary ms-auto"
          disabled={savingAnnouncement}
          onClick={handleSaveAnnouncement}
        >
          {savingAnnouncement ? "Zapisywanie..." : "Zapisz komunikat"}
        </button>
      </div>
    </>
  );
}

export default AnnouncementSettingsForm;
